import {NgModule} from '@angular/core';
import {PracticeSpecialtyService} from './practice-specialty.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [PracticeSpecialtyService]
})
export class PracticeSpecialtyModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/practicespecialty/practice-specialty.module.ts